import { render, staticRenderFns } from "./file-oss-upload.vue?vue&type=template&id=5ac3ab94&scoped=true"
import script from "./file-oss-upload.vue?vue&type=script&lang=js"
export * from "./file-oss-upload.vue?vue&type=script&lang=js"
import style0 from "./file-oss-upload.vue?vue&type=style&index=0&id=5ac3ab94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac3ab94",
  null
  
)

export default component.exports